<template>
  <div class="agreement-pager">
    <section class="scroll-list-wrap">
      <article ref="scroll"
                   :options="options">
        <div class="ql-container">
          <div class="ql-title">有讲课堂隐私政策</div>
          <div class="ql-editor">
            <!-- <h1 class="ql-h1">有讲课堂隐私政策</h1> -->
            <p class="text-right">
              <span>{{ pageTime.update_time_desc }}</span>
            </p>
            <p class="text-right">
              <span>{{ pageTime.effect_time_desc }}</span>
            </p>
            <template v-for="(item, index) in pageContent">
              <h2 :key="index" class="ql-h2">{{ item.title }}</h2>
              <p v-for="iitem in item.texts" :key="iitem">
                <span>{{ iitem }}</span>
              </p>
            </template>
            <!-- 附录 -->
            <h2 class="ql-h2">附件一  第三方SDK目录</h2>
            <div style="overflow-x: auto">
              <table width="100%" style="box-sizing:border-box;width: 100%;">
              <tbody>
                <tr style="display: table-row;">
                  <td>序号</td>
                  <td>第三方SDK名称</td>
                  <td>应用场景描述</td>
                  <td>收集目的</td>
                  <td>触发动作</td>
                  <td>个人信息字段（使用SDK能力，需要提供以下信息才能正常使用功能）</td>
                  <td>机构名称</td>
                  <td>官网链接</td>
                  <td>隐私政策链接</td>
                </tr>
                <template v-for="(item, index) in sdkContent">
                  <tr :key="index" style="display: table-row;">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.desc }}</td>
                    <td>{{ item.purpose }}</td>
                    <td>{{ item.attach }}</td>
                    <td>{{ item.get_msg }}</td>
                    <td>{{ item.compay }}</td>
                    <td><span style="margin: 0px; padding: 0px;"><a style="color: #0052cc; text-decoration: none;" :href="item.link_1">{{ item.link_1 }}</a></span></td>
                    <td><span style="margin: 0px; padding: 0px;"><a style="color: #0052cc; text-decoration: none;" :href="item.link_2">{{ item.link_2 }}</a></span></td>
                  </tr>
                </template>
              </tbody>
            </table>
            </div>


<!--            <div v-for="item in sdkContent" :key="item.name">-->
<!--              <p>-->
<!--                <span>{{ item.name }}</span>-->
<!--              </p>-->
<!--              <p>-->
<!--                <span>使用目的：{{ item.purpose }}</span>-->
<!--              </p>-->
<!--              <p v-if="item.get_msg" v-cloak>-->
<!--                <span>获取信息：{{ item.get_msg }}</span>-->
<!--              </p>-->
<!--              <p>-->
<!--                <span>官方链接：</span>-->
<!--                <a :href="item.link_1" class="text-light">{{ item.link_1 }}</a>-->
<!--              </p>-->
<!--              <p>-->
<!--                <span>隐私政策：</span>-->
<!--                <a :href="item.link_2" class="text-light">点击查看第三方隐私政策</a>-->
<!--              </p>-->
<!--            </div>-->
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import wxShare from '@/common/js/wxShare';
import {
  iosContent,
  androidContent,
  andriodSeriesTime,
  iosSeriesTime,
  androidSdkContent,
  iosSdkContent
} from '@/config/privacyPolicyContentData';
import { isYoJiangApp, isAndroid, isIos } from '@/common/js/utils';

export default {
  computed: {
    options() {
      return {
        scrollbar: true,
        useTransition: false,
      };
    },
  },
  data() {
    return {
      pageTheme: '',
      pageTime: {},
      sdkContent: []
    };
  },
  created() {
    if (isAndroid() && isYoJiangApp()) {
      this.pageContent = androidContent;
      this.pageTheme = 'Android隐私政策';
      this.pageTime = andriodSeriesTime;
      this.sdkContent = androidSdkContent;
    } else if (isIos() && isYoJiangApp()) {
      this.pageContent = iosContent;
      this.pageTheme = 'IOS隐私政策';
      this.pageTime = iosSeriesTime;
      this.sdkContent = iosSdkContent;
    } else if (this.$route.query.type === 'ios') {
      this.pageContent = iosContent;
      this.pageTheme = 'IOS隐私政策';
      this.pageTime = iosSeriesTime;
      this.sdkContent = iosSdkContent;
    } else {
      this.pageContent = androidContent;
      this.pageTheme = 'Android隐私政策';
      this.pageTime = andriodSeriesTime;
      this.sdkContent = androidSdkContent;
    }
  },
  mounted() {
    wxShare();
  },
};
</script>

<style scoped lang="stylus">
  @import "./../../common/stylus/variable.styl"
  @import "./../../common/stylus/mixin.styl"

  table {
    display: table;
    border-collapse: separate;
    box-sizing: border-box;
    text-indent: initial;
    white-space: normal;
    line-height: normal;
    font-weight: normal;
    font-size: medium;
    font-style: normal;
    color: -internal-quirk-inherit;
    text-align: start;
    border-spacing: 2px;
    border-color: grey;
    font-variant: normal;
  }

  td {
    border: 1px solid #c1c7d0;
    padding: 7px 10px;
    vertical-align: top;
    text-align: left;
    min-width: 12px;
  }

  .agreement-pager {
    position: relative
    z-index: 102
    margin: auto
    width: 100vw
    min-height: 100vh
    max-width: 640px
    background-color: #fff
    overflow: hidden
  }

  .ql-container {
    padding: 15px 20px
    width: 100%
    font-family: -apple-system,BlinkMacSystemFont,PingFang SC,Helvetica,Tahoma,Arial,Hiragino Sans GB,Microsoft YaHei,"\5FAE\8F6F\96C5\9ED1",sans-serif
    .ql-title {
      box-sizing: content-box;
      margin: 0;
      width: auto;
      font-size: 22.5pt;
      font-weight: 800
      height: 60px;
      padding-top: 30px;
      border-bottom: 1px solid $color-line-l;
    }
    .ql-editor {
      padding: 20px 0 100px
      text-align: justify
      p {
        line-height: 2
        color: $color-text
        word-wrap: break-word;
        word-break: break-all;
        &.text-right {
          text-align right
        }
        .text-light {
          color #108ee9
        }
      }
    }
    .ql-h1 {
      padding: 0 0 15px;
      font-size: 22px;
      font-weight: 900
      line-height: 36px
      color: $color-text
    }
    .ql-h2 {
      padding: 30px 0 15px;
      font-size: 22px;
      font-weight: 900
      line-height: 36px
      color: $color-text
    }
  }

  // 暗黑模式
  @media (prefers-color-scheme: dark) {
    .agreement-pager {
      background-color: $darkmode-color-bg;
    }
    .ql-container {
      .ql-title {
        border-bottom-color $darkmode-color-line-l
        color: $darkmode-color-text
      }
      .ql-editor {
        p {
          color: $darkmode-color-text
          &.text-right {
            text-align right
          }
        }
      }
      .ql-h1 {
        color: $darkmode-color-text
      }
      .ql-h2 {
        color: $darkmode-color-text
      }
    }
  }

</style>
